import Tax from "features/Taxe/TaxeList/Tax"

const TaxPage:React.FC=()=>{
    return <Tax/>
}
export default TaxPage